import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
	transferAgentName: {
		margin: "16px 32px 0px 32px",
	},
	purpleText: {
		color: tokens.colorPaletteLavenderBorderActive,
	},
});
